(function () {
  var DESKTOP_BREAKPOINT = 1280;

  function normalizeKey(key) {
    if (!key) return '';
    return String(key)
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .replace(/-+/g, '-');
  }

  function tokensFromAlt(altText) {
    if (!altText) return [];
    return String(altText)
      .trim()
      .toLowerCase()
      .split(/\s+/)
      .map(normalizeKey)
      .filter(Boolean);
  }

  function normalizeToken(key) {
    var tokens = tokensFromAlt(key);
    return tokens.length ? tokens[0] : normalizeKey(key);
  }

  function slideMatches(slide, token) {
    if (!token) return false;
    var slideTokens = tokensFromAlt(slide.dataset.mediaAlt || '');
    return slideTokens.indexOf(token) !== -1;
  }

  function getSlides(mediaList) {
    var slides = mediaList.querySelectorAll('.product-gallery-product-slide');
    if (slides.length) return slides;
    return mediaList.querySelectorAll('.product__media-item[data-media-alt]');
  }

  function getSelectedVariantOptionAltKey(buybox) {
    var select = buybox.querySelector('.js__buybox-variant-select-element');
    if (!select || select.selectedIndex < 0) return '';
    var option = select.options[select.selectedIndex];
    if (option && option.dataset.galleryAltKey) {
      return normalizeToken(option.dataset.galleryAltKey);
    }
    return '';
  }

  function getSelectedAltKey(buybox) {
    var purchaseOptions = buybox.querySelector('[data-glow-serum-purchase-options="true"]');
    if (purchaseOptions) {
      var checkedPurchase = purchaseOptions.querySelector('.selling-plan-radio:checked[data-gallery-alt-key]');
      if (checkedPurchase && checkedPurchase.dataset.galleryAltKey) {
        return normalizeToken(checkedPurchase.dataset.galleryAltKey);
      }
      return '';
    }

    var checked = buybox.querySelectorAll('.product__option-item:checked');
    for (var i = 0; i < checked.length; i++) {
      if (checked[i].dataset.galleryAltKey) {
        return normalizeToken(checked[i].dataset.galleryAltKey);
      }
    }

    return getSelectedVariantOptionAltKey(buybox);
  }

  function isVisible(slide) {
    if (!slide) return false;
    if (slide.classList.contains('!hidden') || slide.classList.contains('swiper-slide-hidden')) {
      return false;
    }
    return slide.style.display !== 'none';
  }

  function compactVisibleFirst(mediaList) {
    var slides = Array.from(mediaList.querySelectorAll('.product__media-item'));
    var visible = [];
    var hidden = [];
    slides.forEach(function (slide) {
      if (isVisible(slide)) visible.push(slide);
      else hidden.push(slide);
    });
    visible.concat(hidden).forEach(function (slide) {
      mediaList.appendChild(slide);
    });
  }

  function resetSwiper(swiper) {
    if (!swiper || swiper.destroyed || window.innerWidth >= DESKTOP_BREAKPOINT) return;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.slideTo(0, 0, false);
    if (typeof swiper.setTranslate === 'function') swiper.setTranslate(0);
    swiper.updateProgress();
    swiper.updateSlidesClasses();
    if (swiper.pagination && swiper.pagination.update) swiper.pagination.update();
  }

  function filterGallery(galleryRoot, altKey) {
    var token = normalizeToken(altKey);
    if (!token) return;

    var mediaList = galleryRoot.querySelector('.product__media-list');
    if (!mediaList) return;

    var slides = getSlides(mediaList);
    if (!slides.length) return;

    var matchCount = 0;
    slides.forEach(function (slide) {
      if (slideMatches(slide, token)) matchCount++;
    });

    var showAll = matchCount === 0;
    slides.forEach(function (slide) {
      var matches = showAll || slideMatches(slide, token);
      slide.classList.toggle('!hidden', !matches);
      slide.classList.toggle('swiper-slide-hidden', !matches);
      slide.style.display = matches ? '' : 'none';
      slide.setAttribute('aria-hidden', matches ? 'false' : 'true');
    });

    var swiperEl = galleryRoot.querySelector('.js-gallery-swiper');
    if (!swiperEl || !swiperEl.swiper) return;

    if (window.innerWidth >= DESKTOP_BREAKPOINT) {
      swiperEl.swiper.update();
      return;
    }

    compactVisibleFirst(mediaList);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        resetSwiper(swiperEl.swiper);
      });
    });
  }

  function updateAddToCart(buybox, variantId) {
    var product = window.productData;
    var addBtn = buybox.querySelector('.js-buybox__product-addToCartBtn');
    var stickyBtn = buybox.querySelector('.js-buybox__product-addToCartStickyBtn');
    if (!addBtn || !stickyBtn) return;

    var addText = addBtn.querySelector('span.btnText');
    var stickyText = stickyBtn.querySelector('span.btnText');
    var variant = product && product.variants
      ? product.variants.find(function (v) { return String(v.id) === String(variantId); })
      : null;

    function setAvailable(isAvailable) {
      addBtn.disabled = !isAvailable;
      stickyBtn.disabled = !isAvailable;
      var label = isAvailable ? 'Add to Cart' : 'Sold Out';
      if (addText) addText.textContent = label;
      if (stickyText) stickyText.textContent = label;
    }

    if (variant && variant.available) {
      setAvailable(true);
      return;
    }

    var external = buybox.querySelector(
      '.product__option-item[data-external-variant="true"][aria-label="' + variantId + '"]'
    ) || buybox.querySelector(
      '.selling-plan-radio[data-external-variant="true"][aria-label="' + variantId + '"]'
    );
    var checkedExternal = buybox.querySelector(
      '.product__option-item:checked[data-external-variant="true"]'
    ) || buybox.querySelector(
      '.selling-plan-radio:checked[data-external-variant="true"]'
    );
    if (!external && checkedExternal && String(checkedExternal.getAttribute('aria-label')) === String(variantId)) {
      external = checkedExternal;
    }
    if (!variant && external) {
      setAvailable(external.dataset.available !== 'false');
      return;
    }

    var select = buybox.querySelector('.js__buybox-variant-select-element');
    var option = select ? select.querySelector('option[value="' + variantId + '"]') : null;
    if (!variant && option && !option.disabled) {
      setAvailable(true);
      return;
    }

    setAvailable(false);
  }

  function findExternalProductSelectOption(select, productId, colorValue) {
    var matches = [];
    Array.prototype.forEach.call(select.options, function (opt) {
      if (String(opt.dataset.externalProductId) === String(productId)) matches.push(opt);
    });
    if (!matches.length) return null;
    if (colorValue) {
      for (var i = 0; i < matches.length; i++) {
        if (matches[i].dataset.externalProductColor === colorValue) return matches[i];
      }
    }
    for (var j = 0; j < matches.length; j++) {
      if (!matches[j].disabled) return matches[j];
    }
    return matches[0];
  }

  function syncVariantSelect(buybox) {
    var select = buybox.querySelector('.js__buybox-variant-select-element');
    if (!select) return null;

    var externalProduct = buybox.querySelector('.product__option-item:checked[data-external-product="true"]');
    if (externalProduct) {
      var productId = externalProduct.getAttribute('data-external-product-id');
      var colorInput = buybox.querySelector(
        '[data-color-swatch-set="' + productId + '"]:not([hidden]) .product__option-item:checked'
      );
      if (!colorInput) {
        colorInput = buybox.querySelector('.product__option-item[data-color-option="true"]:checked');
      }
      var externalOption = findExternalProductSelectOption(
        select,
        productId,
        colorInput ? colorInput.value : ''
      );
      if (externalOption) {
        select.value = externalOption.value;
        return externalOption.value;
      }
    }

    var groups = buybox.querySelectorAll('.js__buybox-product-options-group');
    var values = [];
    groups.forEach(function (group) {
      var checked = group.querySelector('.product__option-item:checked');
      if (!checked) return;
      if (group.hasAttribute('data-external-product-choice-group') && checked.dataset.nativeProductChoice === 'true') {
        return;
      }
      values.push(checked.value);
    });

    var title = values.join(' / ');
    var option = select.querySelector('[data-title="' + title + '"]');
    if (!option) {
      var external = buybox.querySelector('.product__option-item:checked[data-external-variant="true"]');
      if (external) {
        option = select.querySelector('option[value="' + external.getAttribute('aria-label') + '"]');
      }
    }
    if (!option) return null;

    select.value = option.value;
    return option.value;
  }

  function init() {
    var galleryRoot = document.querySelector('[data-face-mask-3opt-gallery="true"]');
    var buybox = document.querySelector('.js-buybox');
    if (!galleryRoot || !buybox) return;

    function resolveGalleryAltKey(overrideKey) {
      // Glow serum purchase options remain source of truth — the hidden select may not sync to them.
      var purchaseOptions = buybox.querySelector('[data-glow-serum-purchase-options="true"]');
      if (purchaseOptions) {
        return overrideKey || getSelectedAltKey(buybox);
      }

      // Prefer the selected full variant option key after sync; keep radio/override as fallback.
      return getSelectedVariantOptionAltKey(buybox) || overrideKey || getSelectedAltKey(buybox);
    }

    function apply(overrideKey) {
      var variantId = syncVariantSelect(buybox);
      var selectEl = buybox.querySelector('.js__buybox-variant-select-element');
      if (!variantId && selectEl) variantId = selectEl.value;

      var altKey = resolveGalleryAltKey(overrideKey);
      filterGallery(galleryRoot, altKey);

      if (variantId) updateAddToCart(buybox, variantId);
    }

    function schedule(overrideKey) {
      apply(overrideKey);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { apply(overrideKey); });
      });
    }

    buybox.querySelectorAll('.product__option-item').forEach(function (input) {
      input.addEventListener('change', function (event) {
        schedule(event.target && event.target.dataset ? event.target.dataset.galleryAltKey : '');
      });
    });

    var purchaseOptions = buybox.querySelector('[data-glow-serum-purchase-options="true"]');
    if (purchaseOptions) {
      purchaseOptions.querySelectorAll('.selling-plan-radio[data-gallery-alt-key]').forEach(function (input) {
        input.addEventListener('change', function (event) {
          schedule(event.target && event.target.dataset ? event.target.dataset.galleryAltKey : '');
        });
      });
    }

    schedule();

    document.addEventListener('DOMContentLoaded', function () {
      schedule();
    });

    var swiperEl = galleryRoot.querySelector('.js-gallery-swiper');
    if (swiperEl) {
      var tries = 0;
      var waitForSwiper = window.setInterval(function () {
        tries++;
        if (swiperEl.swiper || tries > 50) {
          window.clearInterval(waitForSwiper);
          schedule();
        }
      }, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
